import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { Carousel, PlaceCard } from '..';

import css from './SectionExplore.module.css';

// ✅ SEO IMPROVEMENT: Link to SEO destination pages instead of search pages
// These pages have curated content, are indexed, and provide better UX
const placeTestData = [
  {
    key: 'CH',
    seoSlugs: {
      'en-US': 'switzerland',
      'de-DE': 'schweiz',
      'fr-FR': 'suisse',
      'it-IT': 'svizzera',
    },
    srcImg: '/static/imgs/switzerland.avif',
  },
  {
    key: 'IT',
    seoSlugs: {
      'en-US': 'italy',
      'de-DE': 'italien',
      'fr-FR': 'italie',
      'it-IT': 'italia',
    },
    srcImg: '/static/imgs/italy.avif',
  },
  {
    key: 'AU',
    seoSlugs: {
      'en-US': 'austria',
      'de-DE': 'osterreich',
      'fr-FR': 'autriche',
      'it-IT': 'austria',
    },
    srcImg: '/static/imgs/austria.avif',
  },
  {
    key: 'FR',
    seoSlugs: {
      'en-US': 'france',
      'de-DE': 'frankreich',
      'fr-FR': 'france',
      'it-IT': 'francia',
    },
    srcImg: '/static/imgs/france.avif',
  },
  {
    key: 'DE',
    seoSlugs: {
      'en-US': 'germany',
      'de-DE': 'deutschland',
      'fr-FR': 'allemagne',
      'it-IT': 'germania',
    },
    srcImg: '/static/imgs/germany.avif',
  },
  {
    key: 'ES',
    seoSlugs: {
      'en-US': 'spain',
      'de-DE': 'spanien',
      'fr-FR': 'espagne',
      'it-IT': 'spagna',
    },
    srcImg: '/static/imgs/spain.avif',
  },
  {
    key: 'NO',
    seoSlugs: {
      'en-US': 'norway',
      'de-DE': 'norwegen',
      'fr-FR': 'norvege',
      'it-IT': 'norvegia',
    },
    srcImg: '/static/imgs/norway.avif',
  },
  {
    key: 'FI',
    seoSlugs: {
      'en-US': 'finland',
      'de-DE': 'finnland',
      'fr-FR': 'finlande',
      'it-IT': 'finlandia',
    },
    srcImg: '/static/imgs/finland.avif',
  }
];

const SectionExplore = props => {
  const { rootClassName, className } = props;
  const sliderRef = React.useRef();

  const classes = classNames(rootClassName || css.root, className);

  const handlePrev = () => {
    if (sliderRef.current) sliderRef.current.slickPrev();
  };

  const handleNext = () => {
    if (sliderRef.current) sliderRef.current.slickNext();
  };

  return (
    <div className={classes}>
      <div className={css.content}>
        <div className={css.headerRow}>
          <div className={css.headerLeft}>
            <span className={css.eyebrow}>
              <FormattedMessage id="SectionExplore.eyebrow" defaultMessage="Explore by destination" />
            </span>
            <h2 className={css.title}>
              <FormattedMessage id="SectionExplore.titlePlace" />
            </h2>
          </div>
          <div className={css.carouselArrows}>
            <button className={css.arrowBtn} onClick={handlePrev} aria-label="Previous">
              ‹
            </button>
            <button className={css.arrowBtn} onClick={handleNext} aria-label="Next">
              ›
            </button>
          </div>
        </div>
        <div className={css.carouselWrapper}>
          <Carousel
            ref={sliderRef}
            className={css.carousel}
            contentClassName={css.carouselContent}
            columns={6}
            showArrows={false}
            responsive={{
              480: { columns: 2 },
              768: { columns: 3 },
              1100: { columns: 4 },
              9999: { columns: 6 },
            }}
          >
            {placeTestData.map(place => (
              <PlaceCard key={place.key} place={place} className={css.placeCard} />
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

SectionExplore.defaultProps = {
  rootClassName: null,
  className: null,
};

SectionExplore.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionExplore;
